import { Injectable, } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  EasFieldControl,
  EasFieldType,
  EasFormGroup,
  EasFormService
} from '@fry/components/common/easform';
import { DashboardDoc } from '@fry/dashboards/lib';
import { map, Observable } from 'rxjs';
import { Role, RolesQuery, RolesStore } from '@fry/lib/roles';
import { SYSTEM_ROLE_ID } from '@fry/lib/roles/roles.system';

const ROLES_BLACK_LIST: string[] = [
  SYSTEM_ROLE_ID.ANONYMOUS_EXTERNAL,
  SYSTEM_ROLE_ID.TIMELINE_OWNER,
];

@Injectable()
export class DashboardFormService {
  public constructor(private rolesStore: RolesStore,
    private formService: EasFormService) {
  }

  public createForm(doc: DashboardDoc): Observable<EasFormGroup> {
    const query: RolesQuery = {
      exclude: ROLES_BLACK_LIST,
      sort: true,
    };

    const form = this.rolesStore.allWithSystem(query).pipe(
      map(roles => {
        const formFields = this.buildFormFields(roles);
        return this.formService.createForm(formFields, doc);
      })
    );
    return form;
  }

    private buildFormFields(roles: Role[]): EasFieldControl[] {
      return [
        {
          id: 'name',
          options: { required: true },
          title: $localize `Name`,
          type: EasFieldType.Field,
          validators: [Validators.required],
          widget: { type: 'string' },
        },
        {
          id: 'roles',
          options: {
            categories: roles.map(r => { return { id: r.id, name: r.title } }),
            required: true
          },
          title: $localize `Roles`,
          type: EasFieldType.Field,
          validators: [Validators.required],
          widget: { type: 'multiSelect' },
        }
      ]
    }
}